<script setup lang="ts">
    import { computed } from 'vue';
    import {
        Select,
        SelectContent,
        SelectGroup,
        SelectItem,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';
    import type { DataTableSelectOption } from '@/types';
    import Indicator from '@/components/Indicator.vue';
    import type { AcceptableValue } from 'reka-ui';

    const props = defineProps<{
        modelValue: AcceptableValue;
        options: DataTableSelectOption[];
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: AcceptableValue];
    }>();

    const selectedOption = computed(() => {
        return props.options.find((option) => option.value === props.modelValue);
    });
</script>

<template>
    <Select
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event as number)"
    >
        <SelectTrigger class="border-none px-0 shadow-none">
            <SelectValue>
                <span class="flex items-center gap-1.5">
                    <Indicator :variant="selectedOption?.color" />
                    {{ selectedOption?.label }}
                </span>
            </SelectValue>
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                <SelectItem
                    v-for="option in options"
                    :key="option.label"
                    :value="option.value"
                >
                    <span class="flex items-center gap-1.5">
                        <Indicator :variant="option.color" />
                        {{ option.label }}
                    </span>
                </SelectItem>
            </SelectGroup>
        </SelectContent>
    </Select>
</template>
